/** Display text derived from F10Q_14 / anomaly detail _15, never free text. */
export function anomalyDocumentType(seqNo: number): string {
  if (seqNo === 1) return '繳庫退出單';
  if (seqNo === 2) return '客訴單';
  return '';
}
